import { SELLER_POSTINGS_APPLICATIONS_TAB_NAMES } from 'sh-www/constants/routes/postings';
import { sellerApplicationsViewRouteFactory } from './index';

export default sellerApplicationsViewRouteFactory(SELLER_POSTINGS_APPLICATIONS_TAB_NAMES.SUBMITTED, '/postings/applications/submitted');
